import { environmentBase } from './environment.base';

export const environment = {
  ...environmentBase,
  production: false,
  apiServer: 'https://stgapi.fullswingapps.com/api/fs',
  hostName: 'stgapi.fullswingapps.com',
  appConfigPath: './assets/config/app-config.json',
  defaultPage: 'event',

  //Local strorage values
  navName: '_fs_nav_name',
  bayManagerUser: 'Bay-Manager-User',
  calendarState: '_fs_fc_state',

  langId: '_fs_lang_id',
  defaultLanguage: 'en',
  defaultFontFamily: 'DavisSans',

  breakPointScreen: {
    small: 576,
    Medium: 768,
    large: 992,
    extraLarge: 1200,
    xExtraLarge: 1400,
  },

  launcherVersion: '1.4.0',
  sseLauncherVersion: '1.8.17',
  legacyConnectionsUrl:
    'https://k0zmbfs553.execute-api.us-west-2.amazonaws.com/staging/bay-manager-explorer',
};
